/* eslint-disable import/prefer-default-export */
import api from 'services';
import { groupsResponse } from 'interfaces/Groups';

export const getGroupsAndPermission = async (application: string): Promise<groupsResponse> => {
  const response = await api.get<groupsResponse>('/groups/groupsandpermission', { params: { application } });
  return response.data;
};
